export const enum RegionDescriptionType {
  REGION = 'REGION',

  DISTRICT = 'DISTRICT',

  COUNCIL = 'COUNCIL',

  VILLAGE = 'VILLAGE',

}
